module.exports = __webpack_public_path__ + "static/media/COLA2018008.0b30853e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/COLA2018008.pdf
// module id = 2271
// module chunks = 1